import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import {
  TextField,
  RaisedButton,
  FlatButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import VenueActions from "../actions/VenueActions";
import VenueStore from "../stores/VenueStore";

import InfoNotice from "./partials/info-notice.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import BackButton from "./partials/back-button.jsx";

import Label from "./partials/label.jsx";

// Used for tag colors
import TagActions from "../actions/TagActions";
import TagStore from "../stores/TagStore";
import { SketchPicker } from "react-color";
import TagPreview from "./partials/tag-preview.jsx";

class Venue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      venue: null,
      dirty: false,
      isFetchingVenue: false,
      values: {}
    };

    this.openSeatmapEditor = this.openSeatmapEditor.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  static getStores() {
    return [VenueStore, TagStore];
  }

  static getPropsFromStores() {
    return {
      getVenueById: VenueStore.getVenueById,
      isSaving: VenueStore.getState().isSaving,
      presetColors: TagStore.getState().presetColors
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  openSeatmapEditor() {
    // Stage edit
    var values = assign({}, this.state.values);
    VenueActions.edit(this.props.params.venueId, values, /* stage */ true);

    this.context.router.push(
      `/event_buckets/${this.props.params.eventBucketId}/venues/${this.props.params.venueId}/edit/seatmap`
    );
  }

  getStyles() {
    return {
      checkboxWrapper: {
        margin: "20px 0"
      },
      actions: {
        marginTop: 40
      },
      h3: {
        marginTop: 30,
        marginBottom: 10
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined"
        ? !get(this.state.values, id)
        : e.target.value
    );
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);
    VenueActions.edit(this.props.params.venueId, values);
    window.scrollTo(0, 0);
  }

  delete() {
    let bucket = this.state.venue.event_bucket;
    if (window.confirm("Are you sure?")) {
      VenueActions.delete(this.props.params.venueId);
      this.context.router.push(`/event_buckets/${bucket}/venues`);
    }
  }

  componentDidMount() {
    this.context.router.setRouteLeaveHook(this.props.route, () => {
      if (this.state.dirty) {
        return "Are you sure you wish to leave the venue editor? Your changes will not be saved.";
      }
    });

    TagActions.fetchPresetColors(); // used in colorpicker
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    // Scroll to top on save to show loader
    if (newProps.isSaving) {
      window.scrollTo(0, 0);
    }

    var venue = newProps.getVenueById(newProps.params.venueId);

    if (!this.state.isFetchingVenue && !venue) {
      VenueActions.fetchOne(newProps.params.venueId);
      this.setState({ isFetchingVenue: true });
    } else if (venue) {
      this.setState({ isFetchingVenue: false });
    }

    this.setState({
      venue,
      dirty: false,
      values: venue
        ? {
            name: venue.name || "",
            short_name: venue.short_name || "",
            description: venue.description || "",
            address: venue.address || "",
            default_capacity: venue.default_capacity || "",
            color: venue.color || "",
            use_reserved_seating: venue.use_reserved_seating,
            seatmap_id: venue.seatmap_id
          }
        : {}
    });
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.venue || this.props.isSaving) {
      return <WorkingIndicator fullPage={true} />;
    }

    let saveButton = (
      <RaisedButton
        label={this.state.dirty ? "Save changes" : "No changes to save"}
        primary={true}
        disabled={!this.state.dirty}
        onTouchTap={this.save}
      />
    );

    return (
      <div>
        {this.props.children /* for seatmap modal */}
        <div>
          <BackButton
            label={
              this.props.location.state && this.props.location.state.fromListing
                ? "venues"
                : "venue"
            }
            style={{ marginRight: 7 }}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/venues/${this.props.params.venueId}`
                  )
            }
          />
          {saveButton}
        </div>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href="http://help.eventive.org/events-and-tickets/create-venues"
            target="_blank"
          >
            guide to creating venues
          </a>
          .
        </InfoNotice>
        <div>
          <div>
            <TextField
              value={get(this.state, "values.name", "")}
              floatingLabelText="Name"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              value={get(this.state, "values.short_name", "")}
              floatingLabelText="Short name (used in tags/filters)"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("short_name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              multiLine={true}
              value={get(this.state, "values.description", "")}
              floatingLabelText="Description"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("description", e.target.value)}
            />
          </div>
          <div>
            <TextField
              multiLine={true}
              rows={2}
              value={get(this.state, "values.address", "")}
              floatingLabelText="Address"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("address", e.target.value)}
            />
          </div>
          <div>
            <Label>Seating</Label>
            <RadioButtonGroup
              name="venue_type"
              valueSelected={this.state.values.use_reserved_seating}
              onChange={(e, v) => this.onChangeValue("use_reserved_seating", v)}
            >
              <RadioButton value={false} label="Open seating" />
              <RadioButton value={true} label="Reserved seating" />
            </RadioButtonGroup>
            {this.state.values.use_reserved_seating ? (
              this.state.values.seatmap_id ? (
                <div style={{ marginTop: 10 }}>
                  <img
                    src={`${
                      this.state.venue.seatmap_preview_image
                    }?_=${Date.now()}`}
                    style={{
                      display: "block",
                      width: 175,
                      border: "1px solid #ccc",
                      padding: 5,
                      marginBottom: "1em"
                    }}
                  />
                  <RaisedButton
                    label="Edit seatmap"
                    onTouchTap={() => this.openSeatmapEditor()}
                    style={{ marginRight: 7 }}
                  />
                  <FlatButton
                    label="Reset"
                    onTouchTap={() => {
                      if (
                        window.confirm(
                          "Are you sure? This will delete your current seatmap permanently. All reservations will be lost. Are you sure you don't just want to make a new venue instead?"
                        )
                      ) {
                        this.onChangeValue("seatmap_id", null);
                        this.save();
                      }
                    }}
                  />
                </div>
              ) : (
                <div style={{ marginTop: 10 }}>
                  <RaisedButton
                    label="Create seatmap"
                    primary={true}
                    style={{ marginRight: 7 }}
                    onTouchTap={() => this.openSeatmapEditor()}
                  />
                  {/*<RaisedButton label="Copy from another venue" />*/}
                </div>
              )
            ) : (
              <TextField
                value={get(this.state, "values.default_capacity", "")}
                floatingLabelText="Default capacity"
                floatingLabelFixed={true}
                placeholder="0"
                onChange={e =>
                  this.onChangeValue("default_capacity", e.target.value)
                }
              />
            )}
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <Label>Tag color</Label>
          <TagPreview
            label={this.state.values.short_name || this.state.values.name}
            color={this.state.values.color}
          />
          <div style={{ marginTop: 10 }}>
            <SketchPicker
              color={this.state.values.color}
              presetColors={this.props.presetColors}
              disableAlpha={true}
              onChange={color => this.onChangeValue("color", color.hex)}
            />
          </div>
        </div>
        <div style={styles.actions}>
          {saveButton}
          <RaisedButton
            label="Delete venue"
            onTouchTap={this.delete}
            style={{ marginLeft: 7 }}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Venue);



// WEBPACK FOOTER //
// ./src/app/components/venue-editor.jsx